import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: 40, suffix: '', label: 'år erfaring' },
  { value: 5, suffix: '+', label: 'partnere' },
  { value: 1000, suffix: '+', label: 'installationer' }
];

export function HeroStats() {
  const [values, setValues] = useState([0, 0, 0]);
  const hasAnimated = useRef(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const element = statsRef.current;
    if (!element) return undefined;

    let frameId;
    const startAnimation = () => {
      if (hasAnimated.current) return;
      hasAnimated.current = true;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setValues(stats.map(({ value }) => value));
        return;
      }

      const duration = 1800;
      const startTime = performance.now();
      const animate = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        const easedProgress = 1 - (1 - progress) ** 3;
        setValues(stats.map(({ value }) => Math.round(value * easedProgress)));
        if (progress < 1) frameId = requestAnimationFrame(animate);
      };

      frameId = requestAnimationFrame(animate);
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      startAnimation();
      observer.disconnect();
    }, { threshold: 0.35 });

    observer.observe(element);
    return () => {
      observer.disconnect();
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <div ref={statsRef} className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-y-8 text-center sm:flex-row sm:flex-wrap" aria-label="JNO Montage i tal">
      {stats.map((stat, index) => (
        <div key={stat.label} className="flex min-w-36 flex-col items-center justify-center">
          <span className="text-4xl font-bold leading-none tracking-tight text-[#0B0E14] sm:text-5xl">{values[index]}{stat.suffix}</span>
          <span className="mt-3 text-base font-light tracking-wide text-[#4B5563] sm:text-lg">{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
